// Обновление страниц в реальном времени (вебсокеты Laravel Reverb через протокол Pusher).
// Сервер шлёт короткое сообщение «в разделах … что-то изменилось» (без данных) — страницы перечитывают свои данные обычными
// запросами. Параметры подключения приходят с сервера (GET /live/config); если вещание выключено, всё работает как раньше.
import Vue from 'vue'
import axios from 'axios'
import Pusher from 'pusher-js'

// Состояние для индикатора в шапке: enabled — вещание настроено, connected — соединение установлено.
export const liveState = Vue.observable({ enabled: false, connected: false })

let pusher = null
const handlers = {}

function dispatch(scopes) {
  scopes.forEach((scope) => {
    const list = handlers[scope] ? Array.from(handlers[scope]) : []
    list.forEach((fn) => {
      try {
        fn()
      } catch (e) {
        // сбой одной страницы не должен мешать остальным
      }
    })
  })
}

// Подписаться на раздел (repairs, orders, routes, zones, fuel, wash, drivers, users, workwear, audit, syncs); возвращает отписку.
export function onLive(scope, fn) {
  if (!handlers[scope]) handlers[scope] = new Set()
  handlers[scope].add(fn)
  return () => handlers[scope].delete(fn)
}

// Подключение после входа: настройки берутся у сервера, при отсутствии вещания ничего не происходит.
export function startLive() {
  if (pusher) return Promise.resolve()
  return axios.get('/live/config')
    .then((res) => {
      const cfg = res.data || {}
      liveState.enabled = !!cfg.enabled
      if (!cfg.enabled || pusher) return
      pusher = new Pusher(cfg.key, {
        cluster: 'mt1', // для Reverb не используется, поле обязательно в библиотеке
        wsHost: cfg.host,
        wsPort: cfg.port,
        wssPort: cfg.port,
        forceTLS: !!cfg.tls,
        enabledTransports: ['ws', 'wss'],
        disableStats: true
      })
      let wasConnected = false
      pusher.connection.bind('connected', () => {
        liveState.connected = true
        // после обрыва связи страницы могли пропустить изменения — все разделы перечитываются
        if (wasConnected) dispatch(Object.keys(handlers))
        wasConnected = true
      })
      pusher.connection.bind('disconnected', () => { liveState.connected = false })
      pusher.connection.bind('unavailable', () => { liveState.connected = false })
      pusher.subscribe(cfg.channel || 'live').bind(cfg.event || 'changed', (message) => {
        dispatch(Array.isArray(message && message.scopes) ? message.scopes : [])
      })
    })
    .catch(() => {
      // без вещания страницы обновляются как раньше
    })
}

export function stopLive() {
  if (pusher) {
    pusher.disconnect()
    pusher = null
  }
  liveState.enabled = false
  liveState.connected = false
}
